import React from 'react'
import { NavLink } from 'react-router-dom'

 import { makeStyles } from 'tss-react/mui'; // if you still want to use makeStyles

const useStyles = makeStyles()((theme) => ({

    footer: {
      
        padding: "20px 20px 5px 20px;",
       /* width: "100%;",
  position: "absolute",
  bottom: "0;",
  left: "0;"
      /*backgroundColor: "#19A78E",
      color: "#fff",
      paddingTop:"50px",
      paddingBottom:"20px",
      
      backgroundImage:"url('/images/footer-background.svg');",
      backgroundRepeat: "no-repeat;",
      backgroundPosition: "center;",
      backgroundSize:"cover;",*/
    },
    copyright:
    {
      fontSize:"10px"
      /*borderTop:"1px solid #fff",
      padding:" 20px 0",
      color: "#fff",
      */
    },
  }));


const Footer = (props) => {

    const { classes } = useStyles();

    return null
    return (
        <footer className={classes.footer}>
          <div className={classes.copyright}>
              Copyright © 2020 <NavLink to="https://spried.com/">spried.com</NavLink>. All rights reserved.
          </div>
        </footer>
    )
}

export default (Footer)